import { LightEffectMode, LightEffectModeType } from '@/define/light'
import { LIGHT_EFFECT_LIST_PRO } from '../light/light_effect_list'
import { CustomLayout, BaseDevice } from '../base_device'
import { DevicePid, EffectIndex, KK } from '@/define/define'

import list_icon from '@/assets/img/device/polar75/list_icon.png'
import { polar75VKCodes } from './keycode/vkeycode'
import { getDeviceKeySquare } from './keysquare/keysquare'
import { generateArray } from '@/tool/utility'

export class Polar75 extends BaseDevice {
  name: string = 'POLAR_75'
  icon: string = list_icon
  width: number = 677
  square = getDeviceKeySquare(DevicePid.IYXPolar75)
  y_number: number = 10
  vkcodes = polar75VKCodes
  lightEffectList: { [name: LightEffectModeType]: EffectIndex } = LIGHT_EFFECT_LIST_PRO

  fnDisableKeys: KK[] = [
    0x16, 0x3a, 0x3b, 0x3c, 0x3d, 0x3e, 0x3f, 0x40, 0x41, 0x42, 0x43, 0x44, 0x45,

    0xe3, 0x4c, 0x4b, 0x4e, 0x52, 0x50, 0x51, 0x4f, 0x04, 0xe4,

    0x2c, 0xe6, 0x49,
  ]
  inoperableKeys: number[] = [0x01]
  customLayout: CustomLayout = {
    0x3a: this.createSquare(8),
    0x3e: this.createSquare(6),
    0x42: this.createSquare(6),
    0x46: this.createSquare(6),

    0x35: this.createSquare(2, this.y_number),
    0x1e: this.createSquare(2, this.y_number),
    0x1f: this.createSquare(2, this.y_number),
    0x20: this.createSquare(2, this.y_number),
    0x21: this.createSquare(2, this.y_number),
    0x22: this.createSquare(2, this.y_number),
    0x23: this.createSquare(2, this.y_number),
    0x24: this.createSquare(2, this.y_number),
    0x25: this.createSquare(2, this.y_number),
    0x26: this.createSquare(2, this.y_number),
    0x27: this.createSquare(2, this.y_number),
    0x2d: this.createSquare(2, this.y_number),
    0x2e: this.createSquare(2, this.y_number),
    0x2a: this.createSquare(2, this.y_number, 55),
    0x49: this.createSquare(2, this.y_number),

    0x2b: this.createSquare(2, 2, 47),
    0x31: this.createSquare(2, 2, 44.5),
    0x39: this.createSquare(2, 2, 48),
    0x28: this.createSquare(2, 2, 82),
    0xe1: this.createSquare(2, 2, 70),
    0xe5: this.createSquare(2, 2, 60.5),
    0xe0: this.createSquare(2, 2, 52),
    0xe2: this.createSquare(2, 2, 52),
    0xe3: this.createSquare(2, 2, 52),
    0x2c: this.createSquare(2, 2, 192),
    0xe6: this.createSquare(2, 2, 52),
    0x01: this.createSquare(2, 2, 52),
    0x50: this.createSquare(19, 2),
  }
  speedAllowValues: number[] = generateArray(0, 5)
  lightAllowValues: number[] = generateArray(0, 5)
  magneticAxis: boolean = true
  resetDes: string = ''
  // win按键锁定
  lockWin: boolean = true
  minDelayTimer: number = 1
  maxDelayTimer: number = 60000
  superResponse = true
  rate: number[] = [8, 4, 2, 1, 0.5, 0.25, 0.125]
}
